import type { FaireProductEntity } from "../../entity_types/product";

export const p_waj7mkq8ae: FaireProductEntity = {
  token: "p_waj7mkq8ae",
  type: "product",
  name: "Skate Truck (Set) South Park x Hydroponic Official Collab.",
  brandToken: "b_9grp69f3nm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8043936972066ff8a558df37130111775642a393078c3370ed90ac0bd6ade5dd.jpeg",
  galleryImageUrls: [],
  priceDollars: 38.31,
  description:
    "Duradero para uso general y cualquier tipo de patinaje, los ejes de skateboard HYDROPONIC cuentan con una aleación de aluminio tratada térmicamente y ligera para ofrecer resistencia, durabilidad y un acabado pulido de la más alta calidad y durabilidad disponible.\n\nBujes de rebote súper alto de 90A para garantizar un flujo perfecto en las curvas.\n\nBaseplate negro\n\nKingpin hueco\n\nJuego de 2 ejes",
  tags: [],
  msrpDollars: 76.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:47.600Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
